import { computed, inject, Injectable, signal } from '@angular/core';
import { shareReplay } from 'rxjs';

import { environment } from '../../environments/environment';
import { CategoryDto } from '../api';
import { CategoriesService } from '../api/api/categories.service';
import { retryWithBackoff } from './rxjs-operators';

@Injectable({ providedIn: 'root' })
export class CachedCategoriesService {
  private service = inject(CategoriesService);
  categories = signal<CategoryDto[]>([]);
  categoriesMap = computed(() => new Map(this.categories().map((category) => [category.id, category])));

  constructor() {
    this.loadCategories();
  }

  loadCategories() {
    this.service.listCategories().pipe(retryWithBackoff(), shareReplay(1)).subscribe({
      next: this.categories.set,
    });
  }

  getCategoryImage(categoryId: number): { url: string; isSectorImage: boolean } {
    const category = this.categoriesMap().get(categoryId);
    if (category?.image_urls.length) {
      return { url: category.image_urls[Math.floor(Math.random() * category.image_urls.length)], isSectorImage: true };
    }
    return { url: environment.defaultImageUrl, isSectorImage: true };
  }
}
